import { ExpectedError } from '@adornis/validation/errors/ExpectedError.js';

export class RegistrationSuspendedError extends ExpectedError {
  static override _class = 'RegistrationSuspendedError';

  public constructor() {
    super('RegistrationSuspendedError', {
      translationKey: 'REGISTRATION_SUSPENDED_ERROR',
    });
  }
}
